import { SITE_LEVEL_PAGE_ID, tpaPageIdToItemTypeConfig } from '@wix/a11y-wizard-common';
import { getPagesDataForAnalysis } from '@wix/ambassador-promote-accessibility-v2-rule-execution-result/http';
import { fetchSiteStructure } from '../api/fetch-site-structure';
export const mapPageIdToPageDataFromServer = async (a11yWizardAdapter, i18n, httpClient, errorHandler) => {
  const {
    nonGeneralPageIdPagesGroupMap
  } = (a11yWizardAdapter.getAllPagesData == null ? void 0 : a11yWizardAdapter.getAllPagesData()) || {};
  const {
    data
  } = await httpClient.request(getPagesDataForAnalysis({}));
  const {
    staticPages = [],
    templatePages = []
  } = data;
  const customMembersPages = a11yWizardAdapter.getMembersCustomPages();
  const isMembershipCustomPage = pageId => customMembersPages.signIn.id === pageId || customMembersPages.signUp.id === pageId;
  const staticPageDataEntries = staticPages.map(page => [page.pageId ?? '', isMembershipCustomPage(page.pageId ?? '') ? transformMembershipCustomPageToClientType(page, customMembersPages, nonGeneralPageIdPagesGroupMap, i18n) : transformStaticPageToClientType(page, nonGeneralPageIdPagesGroupMap, i18n)]);
  const templatePageDataEntries = await Promise.all(templatePages.map(async page => [page.pageId ?? '', await transformTemplatePageToClientType(page, nonGeneralPageIdPagesGroupMap, i18n, httpClient, errorHandler)]));
  const filteredTemplatePageDataEntries = templatePageDataEntries.filter(_ref => {
    let [_, {
      innerRoutes
    }] = _ref;
    return ((innerRoutes == null ? void 0 : innerRoutes.length) ?? 0) > 0;
  });
  const siteLevelPageData = [SITE_LEVEL_PAGE_ID, {
    dividerTitle: i18n.t('accessibility-wizard.rule-group.label.site-level'),
    itemType: 'SITE_LEVEL',
    title: i18n.t('accessibility-wizard.rule-group.label.site-level'),
    tpaPage: false,
    urlPath: ''
  }];
  return new Map([siteLevelPageData, ...staticPageDataEntries, ...filteredTemplatePageDataEntries]);
};
function transformStaticPageToClientType(page, nonGeneralPageIdPagesGroupMap, i18n) {
  var _nonGeneralPageIdPage;
  const {
    pageId,
    membershipCustomPage,
    itemType,
    title,
    path
  } = page;
  return {
    dividerTitle: (pageId && (nonGeneralPageIdPagesGroupMap == null || (_nonGeneralPageIdPage = nonGeneralPageIdPagesGroupMap[pageId]) == null ? void 0 : _nonGeneralPageIdPage.name)) ?? i18n.t('accessibility-wizard.groups-list.dividers-titles.default'),
    isMembershipCustomPage: membershipCustomPage ?? false,
    itemType: itemType,
    title: title ?? '',
    tpaPage: false,
    urlPath: path ?? ''
  };
}
async function transformTemplatePageToClientType(page, nonGeneralPageIdPagesGroupMap, i18n, httpClient, errorHandler) {
  var _nonGeneralPageIdPage2;
  const {
    pageId,
    itemType,
    title,
    templatePageIntentId
  } = page;
  const itemTypeConfig = templatePageIntentId ? tpaPageIdToItemTypeConfig[templatePageIntentId] : undefined;
  const innerRoutes = itemTypeConfig ? await fetchSiteStructure(httpClient, itemTypeConfig, errorHandler) : undefined;
  return {
    dividerTitle: (pageId && (nonGeneralPageIdPagesGroupMap == null || (_nonGeneralPageIdPage2 = nonGeneralPageIdPagesGroupMap[pageId]) == null ? void 0 : _nonGeneralPageIdPage2.name)) ?? i18n.t('accessibility-wizard.groups-list.dividers-titles.default'),
    innerRoutes,
    itemType: itemType,
    title: title ?? '',
    tpaPage: true,
    urlPath: ''
  };
}
function transformMembershipCustomPageToClientType(page, customMembersPages, nonGeneralPageIdPagesGroupMap, i18n) {
  var _customMembersPages$s, _customMembersPages$s2, _customMembersPages$s3, _nonGeneralPageIdPage3;
  const {
    pageId,
    itemType,
    title,
    path
  } = page;
  const isSignUpPage = pageId === (customMembersPages == null || (_customMembersPages$s = customMembersPages.signUp) == null ? void 0 : _customMembersPages$s.id);
  const customPageTitle = isSignUpPage ? customMembersPages == null || (_customMembersPages$s2 = customMembersPages.signUp) == null ? void 0 : _customMembersPages$s2.title : customMembersPages == null || (_customMembersPages$s3 = customMembersPages.signIn) == null ? void 0 : _customMembersPages$s3.title;
  return {
    dividerTitle: (pageId && (nonGeneralPageIdPagesGroupMap == null || (_nonGeneralPageIdPage3 = nonGeneralPageIdPagesGroupMap[pageId]) == null ? void 0 : _nonGeneralPageIdPage3.name)) ?? i18n.t('accessibility-wizard.groups-list.dividers-titles.default'),
    isMembershipCustomPage: true,
    itemType: itemType,
    title: customPageTitle ?? title ?? '',
    tpaPage: false,
    urlPath: path ?? ''
  };
}
//# sourceMappingURL=map-page-id-to-page-data-server.js.map